




































































import Vue from 'vue';
import validators from '@/validators';
import {Donor} from "@/interfaces/donation/donor";

export default Vue.extend({
  props: {
    value: {
      type: Object as () => Donor,
    },
  },
  data() {
    return {
      rules: {},
    };
  },
  computed: {
    donor: {
      get():Donor {
        return this.value
      },
      set(val:Donor) {
        this.$emit('update:value', val)
      }
    },
  },
  created() {
    // NOTE: This might be an issue if language is to be changed runtime
    Object.assign(this.rules, validators(this.$t('validation')));
  },
  methods: {
    t(label) {
      const $te = this.$te.bind(this);
      const $t = this.$t.bind(this);
      return $te(label) ? $t(label) : undefined;
    },
  },
})
;
